import { createSelector } from 'reselect'

const getState = state => state.auth
const isLoadingSelector = state => getState(state).isLoading
const isSignedInSelector = state => getState(state).signedIn

const authDataSelector = createSelector(
  getState,
  ({ login, password }) => ({ login, password })
)

export {
  isLoadingSelector,
  isSignedInSelector,
  authDataSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/AuthSelectors.js